export const getSeekerPercentClick = e => {
  const rect = e.currentTarget.getBoundingClientRect();
  const x = e.clientX - rect.left;
  const width = rect.width;
  return 100 * x / width;
}
